"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.prompt-assist.disabled': 'Funkcja asystenta promptów nie jest dostępna w Twoim obecnym planie.',
};
